import RequestStatus from "types/general/requests/RequestStatus"
// import { TIsaDataActionTypes, FETCH_ISA_CONTENTS_SUCCESS, FETCH_ISA_LINES_SUCCESS, FETCH_ISA_SUBLINES_SUCCESS, FETCH_ISA_COMPS_SUCCESS, FETCH_ISA_PARAMS_SUCCESS, FETCH_ISA_RISK2_SUCCESS, FETCH_ISA_RISK3_SUCCESS } from "types/actions/backend_data_actions/isa/TIsaDataActionTypes"
import { IsaContent, IsaLine, IsaSubline, IsaComposition, IsaParameter, IsaRiskGroup2Packing, IsaRiskGroup3Packing } from "types/backend_models/isa/IsaModels"
import { IDefaultRequestProps } from "types/general/GeneralStateModelInterfaces"
import {
    createSlice,
    PayloadAction,
    CaseReducer
} from "@reduxjs/toolkit";

interface IIsaStateObject<T> extends IDefaultRequestProps {
    data: T[] | null
}

interface IIsaDataState {
    /** Will be true when all isa data has been fetched succesfully. */
    succes: boolean,
    isaContents: IIsaStateObject<IsaContent>,
    isaLines: IIsaStateObject<IsaLine>,
    isaSublines: IIsaStateObject<IsaSubline>,
    isaCompositions: IIsaStateObject<IsaComposition>,
    isaParameters: IIsaStateObject<IsaParameter>,
    isaRiskGroup2Packings: IIsaStateObject<IsaRiskGroup2Packing>,
    isaRiskGroup3Packings: IIsaStateObject<IsaRiskGroup3Packing>
}

const defaultState: IIsaDataState = {
    succes: false,
    isaContents: {
        requestStatus: RequestStatus.idle,
        data: null,
        error: null
    },
    isaLines: {
        requestStatus: RequestStatus.idle,
        data: null,
        error: null
    },
    isaSublines: {
        requestStatus: RequestStatus.idle,
        data: null,
        error: null
    },
    isaCompositions: {
        requestStatus: RequestStatus.idle,
        data: null,
        error: null
    },
    isaParameters: {
        requestStatus: RequestStatus.idle,
        data: null,
        error: null
    },
    isaRiskGroup2Packings: {
        requestStatus: RequestStatus.idle,
        data: null,
        error: null
    },
    isaRiskGroup3Packings: {
        requestStatus: RequestStatus.idle,
        data: null,
        error: null
    },
}

/* ACTION REDUCERS */
function AllIsaObjectsFetched(state: IIsaDataState) {
    if (state.isaContents.requestStatus !== RequestStatus.succes) return false;
    if (state.isaLines.requestStatus !== RequestStatus.succes) return false;
    if (state.isaSublines.requestStatus !== RequestStatus.succes) return false;
    if (state.isaCompositions.requestStatus !== RequestStatus.succes) return false;
    if (state.isaParameters.requestStatus !== RequestStatus.succes) return false;
    if (state.isaRiskGroup2Packings.requestStatus !== RequestStatus.succes) return false;
    if (state.isaRiskGroup3Packings.requestStatus !== RequestStatus.succes) return false;
    return true;
}

interface IsaActionReducer<T> extends CaseReducer<IIsaDataState, PayloadAction<T>> { }

const FetchIsaContentsSuccesActionReducer: IsaActionReducer<IsaContent[]> = (state: IIsaDataState, action) => {
    state.isaContents.data = action.payload;
    state.isaContents.requestStatus = RequestStatus.succes;
    state.succes = AllIsaObjectsFetched(state);
}
const FetchIsaLinesSuccesActionReducer: IsaActionReducer<IsaLine[]> = (state: IIsaDataState, action) => {
    state.isaLines.data = action.payload;
    state.isaLines.requestStatus = RequestStatus.succes;
    state.succes = AllIsaObjectsFetched(state);
}
const FetchIsaSubLinesSuccesActionReducer: IsaActionReducer<IsaSubline[]> = (state: IIsaDataState, action) => {
    state.isaSublines.data = action.payload;
    state.isaSublines.requestStatus = RequestStatus.succes;
    state.succes = AllIsaObjectsFetched(state);
}
const FetchIsaCompositionsSuccesActionReducer: IsaActionReducer<IsaComposition[]> = (state: IIsaDataState, action) => {
    state.isaCompositions.data = action.payload;
    state.isaCompositions.requestStatus = RequestStatus.succes;
    state.succes = AllIsaObjectsFetched(state);
}
const FetchIsaParametersSuccesActionReducer: IsaActionReducer<IsaParameter[]> = (state: IIsaDataState, action) => {
    state.isaParameters.data = action.payload;
    state.isaParameters.requestStatus = RequestStatus.succes;
    state.succes = AllIsaObjectsFetched(state);
}
const FetchIsaRiskGroup2PackingSuccesActionReducer: IsaActionReducer<IsaRiskGroup2Packing[]> = (state: IIsaDataState, action) => {
    state.isaRiskGroup2Packings.data = action.payload;
    state.isaRiskGroup2Packings.requestStatus = RequestStatus.succes;
    state.succes = AllIsaObjectsFetched(state);
}
const FetchIsaRiskGroup3PackingSuccesActionReducer: IsaActionReducer<IsaRiskGroup3Packing[]> = (state: IIsaDataState, action) => {
    state.isaRiskGroup3Packings.data = action.payload;
    state.isaRiskGroup3Packings.requestStatus = RequestStatus.succes;
    state.succes = AllIsaObjectsFetched(state);
}

/* REDUCER */
const isaSlice = createSlice({
    name: "isa",
    initialState: defaultState,
    reducers: {
        fetchIsaContentsSucces: FetchIsaContentsSuccesActionReducer,
        fetchIsaLinesSucces: FetchIsaLinesSuccesActionReducer,
        fetchIsaSubLinesSucces: FetchIsaSubLinesSuccesActionReducer,
        fetchIsaCompositionsSucces: FetchIsaCompositionsSuccesActionReducer,
        fetchIsaParametersSucces: FetchIsaParametersSuccesActionReducer,
        fetchIsaRiskGroup2PackingSucces: FetchIsaRiskGroup2PackingSuccesActionReducer,
        fetchIsaRiskGroup3PackingSucces: FetchIsaRiskGroup3PackingSuccesActionReducer,
    }
})

export const {
    fetchIsaContentsSucces,
    fetchIsaLinesSucces,
    fetchIsaSubLinesSucces,
    fetchIsaCompositionsSucces,
    fetchIsaParametersSucces,
    fetchIsaRiskGroup2PackingSucces,
    fetchIsaRiskGroup3PackingSucces
} = isaSlice.actions;

export default isaSlice.reducer;

/* OLD REDUCER
export function isaDataReducer(state = defaultState, action: TIsaDataActionTypes): IIsaDataState {
    switch (action.type) {
        case FETCH_ISA_CONTENTS_SUCCESS: {
            return {
                ...state,
                isaContents: {
                    ...state.isaContents,
                    requestStatus: RequestStatus.succes,
                    data: action.data,
                }
            }
        }
        case FETCH_ISA_LINES_SUCCESS: {
            return {
                ...state,
                isaLines: {
                    ...state.isaContents,
                    requestStatus: RequestStatus.succes,
                    data: action.data,
                }
            }
        }
        case FETCH_ISA_SUBLINES_SUCCESS: {
            return {
                ...state,
                isaSublines: {
                    ...state.isaContents,
                    requestStatus: RequestStatus.succes,
                    data: action.data,
                }
            }
        }
        case FETCH_ISA_COMPS_SUCCESS: {
            return {
                ...state,
                isaCompositions: {
                    ...state.isaContents,
                    requestStatus: RequestStatus.succes,
                    data: action.data,
                }
            }
        }
        case FETCH_ISA_PARAMS_SUCCESS: {
            return {
                ...state,
                isaParameters: {
                    ...state.isaContents,
                    requestStatus: RequestStatus.succes,
                    data: action.data,
                }
            }
        }
        case FETCH_ISA_RISK2_SUCCESS: {
            return {
                ...state,
                isaRiskGroup2Packings: {
                    ...state.isaContents,
                    requestStatus: RequestStatus.succes,
                    data: action.data,
                }
            }
        }
        case FETCH_ISA_RISK3_SUCCESS: {
            return {
                ...state,
                isaRiskGroup3Packings: {
                    ...state.isaContents,
                    requestStatus: RequestStatus.succes,
                    data: action.data,
                }
            }
        }
        default: {
            return state;
        }
    }
}

export default isaDataReducer
*/